
ko.bindingHandlers.slashedName = {
    update: function (elem, valueAccessor) {
        const encodeHtml = (html) => {
            return document.createElement('a').appendChild(
                document.createTextNode(html)).parentNode.innerHTML;
        }


        const value = ko.utils.unwrapObservable(valueAccessor());

        elem.innerHTML = value.split('/').map(i => encodeHtml(i)).join('<span style="color:#bdbdbd;"> / </span>')

         
    }
}
ko.virtualElements.allowedBindings.animate = true;
